/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React from 'react';
import ThreeDotsLoader from '../../../../Components/LoadingDots';

function DeleteResourceModal({
    setDeleteModal, deleteModal, handleDelete, selectedCategory, threeDotLoader, setThreeDotsLoader,
}) {
    return (
        <div className={`modal fade fixed top-0 left-0 ${deleteModal ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="DeleteresourceModal" tabIndex="-1" aria-labelledby="activateOfferModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none max-w-[441px]" style={{ margin: 'auto' }}>
                <div
                    className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
                >
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                            Delete Resource
                        </h5>
                        <button
                            type="button"
                            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        />
                    </div>
                    <div className="modal-body relative px-8 pt-5 pb-5 text-center">
                        <p className="text-xs6 font-normal text-[#555259]">
                            Are you sure you want to delete "
                            {selectedCategory.title}
                            "?
                        </p>
                    </div>
                    <div className="modal-footer flex flex-shrink-0 flex-wrap justify-evenly pb-[22px] rounded-b-md">
                        <button
                            type="button"
                            className="border border-[#555259] bg-[#FFFFFF] text-base font-normal text-[#555259] px-14 py-3 rounded-lg"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setDeleteModal(false)}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="border border-[#673593] bg-[#555259] text-base font-normal text-[#ffffff] py-3 px-16 rounded-lg delete-resource"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => handleDelete()}
                        >
                            {threeDotLoader ? <ThreeDotsLoader /> : 'Yes'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DeleteResourceModal;
